/**
 * Pool wire events — content fetch telemetry. Single owner of these `/dye`
 * types and their params.
 */

import type { EventParams } from '../../core/analytics/track';

export const POOL_EVENTS = {
  contentFetchStart: 'sdk:content_fetch_start',
  contentFetchSuccess: 'sdk:content_fetch_success',
  contentFetchError: 'sdk:content_fetch_error',
} as const;

export type PoolEventType = (typeof POOL_EVENTS)[keyof typeof POOL_EVENTS];

export interface ContentFetchPayload {
  kind: 'website' | 'post';
  domain?: string;
  locale?: string;
  id?: string;
  ms?: number;
  error?: string;
}

export function buildContentFetchParams(payload: ContentFetchPayload): EventParams {
  const out: EventParams = {};
  for (const [key, value] of Object.entries(payload)) {
    if (value === undefined || value === null) continue;
    out[key] = typeof value === 'string' || typeof value === 'number' ? value : String(value);
  }
  return out;
}
